import { NEXT_PAGE, PREV_PAGE } from '../constants/pagination';
import { getSessionStorage, translateWithComponent } from '../utils';

/**
 * @type {import('./index.d').updateProductCount}
 */
export const updateProductCount = (context, limit, totalProduct) => {
  const translationData = {
    from: (getSessionStorage(PREV_PAGE) - 1) * limit + 1,
    to: Math.min(limit * getSessionStorage(NEXT_PAGE), totalProduct),
    total: totalProduct,
    count: totalProduct,
  };

  const paginationConfig = getProductCountTranslationConfig(context, 'pagination', totalProduct);
  const toolbarConfig = getProductCountTranslationConfig(context, 'toolbar', totalProduct);

  updateTextContent(paginationConfig, translationData);
  updateTextContent(toolbarConfig, translationData);
};

/**
 * @type {import('./index.d').getProductCountTranslationConfig}
 */
const getProductCountTranslationConfig = (context, position, totalProduct) => {
  const isToolbar = position === 'toolbar';
  const baseKey = isToolbar ? 'Toolbar' : 'Pagination';
  const isPlural = totalProduct > 1;
  let key = `productCount.textDescription${baseKey}`;
  let fallback = isToolbar ? '{{count}} product' : 'Showing {{from}} - {{to}} of {{total}} product';

  if (isPlural) {
    key += 'Plural';
    fallback += 's';
  }

  return {
    context,
    element: isToolbar
      ? context.document.querySelector('.boost-sd__toolbar-item .boost-sd__product-count')
      : context.document.querySelector('.boost-sd__product-count-pagination'),
    key,
    fallback,
  };
};

/**
 * @type {import('./index.d').updateTextContent}
 */
const updateTextContent = ({ context, element, key, fallback }, translationData) => {
  if (!element) return;
  const content = translateWithComponent(context.translate(key, fallback), translationData);
  setTimeout(() => {
    element.textContent = content;
  }, 500);
};
